module.exports = __webpack_public_path__ + "img/banner.a81699aa.png";